// extracted by mini-css-extract-plugin
export var card = "_lu-0";
export var content = "_lu-2";
export var details = "_lu-3";
export var icon = "_lu-1";
export var iconBlue = "_lu-5";
export var iconBrand = "_lu-4";
export var iconGrayBlue = "_lu-6";
export var iconGreen = "_lu-7";
export var iconIndigo = "_lu-8";
export var iconOrange = "_lu-9";
export var iconPurple = "_lu-a";
export var iconRed = "_lu-b";
export var iconWarning = "_lu-c";